import axios from "../axiosConfig.js";
import { DEFAULT_API_URL } from "../config";
import {
    GET_MY_PLANS_SUCCESS,
    GET_MY_PLANS_FAILED,
    GET_MY_PLANS_LOADING,
    GET_PLANS_SUCCESS,
    GET_PLANS_FAILED,
    GET_PLANS_LOADING,
    SHARE_PLAN_SUCCESS,
    SHARE_PLAN_FAILED,
    SHARE_PLAN_LOADING,
    ADMIN_SHARE_PLAN_SUCCESS,
    ADMIN_SHARE_PLAN_FAILED,
    ADMIN_SHARE_PLAN_LOADING,
    GET_SAVED_PLANS_SUCCESS,
    GET_SAVED_PLANS_FAILED,
    GET_SAVED_PLANS_LOADING,
    ADD_SAVED_PLAN_SUCCESS,
    ADD_SAVED_PLAN_FAILED,
    ADD_SAVED_PLAN_LOADING,
    REMOVE_SAVED_PLAN_SUCCESS,
    REMOVE_SAVED_PLAN_FAILED,
    REMOVE_SAVED_PLAN_LOADING,
} from "./types";
import { createMessage } from "../messages";
import { headerHelper } from "../auth/auth";
import errorHandler from "../errorHandler";

//   <------------ GET PLANS ------------>   //
export const getPlans = () => (dispatch, getState) => {
    dispatch({ type: GET_PLANS_LOADING });

    axios
        .get(`${DEFAULT_API_URL}/plans/plans/`, headerHelper(getState))
        .then((res) => {
            dispatch({
                type: GET_PLANS_SUCCESS,
                payload: res.data,
            });
        })
        .catch((err) => {
            errorHandler(dispatch, err, GET_PLANS_FAILED, "Getting Plans");
        });
};

//   <------------ GET MY PLANS ------------>   //
export const getMyPlans = () => (dispatch, getState) => {
    dispatch({ type: GET_MY_PLANS_LOADING });

    axios
        .get(`${DEFAULT_API_URL}/plans/plans/my_plans/`, headerHelper(getState))
        .then((res) => {
            dispatch({
                type: GET_MY_PLANS_SUCCESS,
                payload: res.data,
            });
        })
        .catch((err) => {
            errorHandler(dispatch, err, GET_MY_PLANS_FAILED, "Getting Plans");
        });
};

//   <--------------------------- ADMIN_SHARE_PLAN --------------------------->   //
export const adminSharePlan = (userId, planId) => (dispatch, getState) => {

    dispatch({ type: ADMIN_SHARE_PLAN_LOADING });

    axios
        .post(
            `${DEFAULT_API_URL}/plans/plan_full_access/`,
            {
                user: userId,
                building_plan: planId,
                role:"OWNER"
            },
            headerHelper(getState)
        )
        .then((res) => {
            dispatch({
                type: ADMIN_SHARE_PLAN_SUCCESS,
                payload: res.data,
            });
            dispatch(createMessage(`Given plan access to user`));
        })
        .catch((err) => {
            errorHandler(
                dispatch,
                err,
                ADMIN_SHARE_PLAN_FAILED,
                "Giving Plan Access"
            );
        });
};

//   <--------------------------- SHARE_PLAN --------------------------->   //
export const sharePlan = (projectId, email, role) => (dispatch, getState) => {
    //
    const data = {
        email: email,
        role: role,
    };

    dispatch({ type: SHARE_PLAN_LOADING });

    axios
        .post(
            `${DEFAULT_API_URL}/projects/projects/${projectId}/grant_access/`,
            data,
            headerHelper(getState)
        )
        .then((res) => {
            dispatch({
                type: SHARE_PLAN_SUCCESS,
                payload: res.data,
            });
            dispatch(createMessage(`Shared plan with ${email}`));
        })
        .catch((err) => {
            errorHandler(
                dispatch,
                err,
                SHARE_PLAN_FAILED,
                "Sharing Plan Access"
            );
        });
};

//   <------------ GET_SAVED_PLANS ------------>   //
export const getSavedPlans = () => (dispatch, getState) => {
    dispatch({ type: GET_SAVED_PLANS_LOADING });

    axios
        .get(
            `${DEFAULT_API_URL}/plans/plan_bookmarks/my_bookmarked_plans/`,
            headerHelper(getState)
        )
        .then((res) => {
            dispatch({
                type: GET_SAVED_PLANS_SUCCESS,
                payload: res.data,
            });
        })
        .catch((err) => {
            errorHandler(
                dispatch,
                err,
                GET_SAVED_PLANS_FAILED,
                "Getting saved plans"
            );
        });
};

//   <--------------------------- ADD_SAVED_PLAN --------------------------->   //
export const addSavedPlan = (building_plan) => (dispatch, getState) => {
    dispatch({ type: ADD_SAVED_PLAN_LOADING });
    //
    const data = {
        building_plan: building_plan,
    };

    axios
        .post(
            `${DEFAULT_API_URL}/plans/plan_bookmarks/add_plan/`,
            data,
            headerHelper(getState)
        )
        .then((res) => {
            dispatch({
                type: ADD_SAVED_PLAN_SUCCESS,
                payload: res.data,
            });
            dispatch(createMessage(`Plan saved`));
            dispatch(getSavedPlans());
        })
        .catch((err) => {
            errorHandler(dispatch, err, ADD_SAVED_PLAN_FAILED, "Saving plan");
        });
};

//   <--------------------------- REMOVE_SAVED_PLAN --------------------------->   //
export const removeSavedPlan = (building_plan) => (dispatch, getState) => {
    dispatch({ type: REMOVE_SAVED_PLAN_LOADING });
    //
    const data = {
        building_plan: building_plan,
    };

    axios
        .post(
            `${DEFAULT_API_URL}/plans/plan_bookmarks/remove_plan/`,
            data,
            headerHelper(getState)
        )
        .then((res) => {
            dispatch({
                type: REMOVE_SAVED_PLAN_SUCCESS,
                payload: res.data,
            });
            dispatch(createMessage(`Plan removed from saved`));
            dispatch(getSavedPlans());
        })
        .catch((err) => {
            errorHandler(
                dispatch,
                err,
                REMOVE_SAVED_PLAN_FAILED,
                "Removing plan from saved"
            );
        });
};
